import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import DashboardsListPage from 'features/dashboards/pages/DashboardsListPage';
import DashboardViewPage from 'features/dashboards/pages/DashboardViewPage';
import TrodoLoader from 'shared/components/ui/TrodoLoader';
import { listDashboards } from 'features/dashboards/api/dashboardsApi';
import { errorText } from 'features/dashboards/format';

/**
 * /:team/reports/*
 *   /:team/reports        list of the team's reports
 *   /:team/reports/:id    one report (?tab=, ?t=, filters in the URL)
 * The team's default board is not a report: it is the Overview, at /:team/overview.
 */
export default function DashboardsPage() {
  const { team } = useParams();
  const { pathname } = useLocation();
  const base = `/${encodeURIComponent(team)}/reports`;
  const rest = pathname.startsWith(base) ? pathname.slice(base.length).replace(/^\/+|\/+$/g, '') : '';
  const id = rest.split('/')[0];
  if (!id) return <DashboardsListPage />;
  if (id === 'overview') return <Navigate to={`/${encodeURIComponent(team)}/overview`} replace />;
  return <DashboardViewPage dashboardId={id} />;
}

/** /:team/overview — every team's default board. */
export function OverviewPage() {
  const { team } = useParams();
  return <DefaultDashboard team={team} />;
}

/** The Overview keeps one address; its id is the team's default dashboard. */
function DefaultDashboard({ team }) {
  const [state, setState] = useState({ id: null, error: null });
  useEffect(() => {
    let alive = true;
    listDashboards(team)
      .then((list) => { const d = list.find((x) => x.is_default); if (alive) setState({ id: d ? d.id : null, error: d ? null : 'This team has no Overview.' }); })
      .catch((e) => { if (alive) setState({ id: null, error: errorText(e) }); });
    return () => { alive = false; };
  }, [team]);
  if (state.id) return <DashboardViewPage key={state.id} dashboardId={String(state.id)} overview />;
  if (state.error) {
    return (
      <main className="flex flex-1 items-center justify-center bg-surface p-8">
        <div className="max-w-md rounded-md border border-[color:var(--feedback-error)] bg-danger-soft px-4 py-3 text-[13px] text-danger">{state.error}</div>
      </main>
    );
  }
  return <main className="flex flex-1 items-center justify-center bg-surface"><TrodoLoader label="Loading the overview" /></main>;
}
